<template>
    <div class="container touch-page" id="content">
        <div id="text" class="row">
            <div class="col-lg-6">
                <img src="../../static/img/logo_big.png" alt="Logo">
            </div>
            <div class="col-lg-6">
                <h1 class="text-left">League and club competition<br>
                    results</h1>
                <div class="buttons">
                    <router-link class="btn btn-big" active-class="active" to="/leagues">Leagues</router-link>
                    <router-link class="btn btn-big" active-class="active" to="/competitions">Competitions</router-link>
                    <router-link class="btn btn-big" active-class="active" to="/diary">Diary</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"Home"
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   .btn-league.router-link-exact-active, .buttons a.router-link-exact-active {
        background: #7b7b7b;
    }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue